import "antd/lib/tabs/style/css";

import React from "react";
import { Translate } from "react-localize-redux";

import ZigybetImage from "@assets/images/zigybet.png";
import {
	BackgroundCard,
	CasinoSlider,
	MostPlayedSlider,
	ProvidersSlider,
	ScrollToTop,
	WinnersSlider,
} from "@pages/casino/components";
import { GameFilters, PromotionBanner } from "@pages/casino/containers";
import RollblockSearchBox from "@pages/casino/containers/RollblockSearchBox/index.jsx";
import { BettoFavoritesBrowse } from "@pages/casino/pages/favorites/betto";
import { getTournamentOptions } from "@pages/casino/utils";
import { isBettoFavoritesActive } from "@pages/casino/utils/bettoProviderFilter";
import BettoLobbyTopBanner from "@pages/home/betto/lobbyTopBanner/index.jsx";
import BettoProviders from "@pages/home/betto/providers/index.jsx";
import { BettoWonSlider } from "@pages/home/betto/wonSlider/index.jsx";
import begambleawarenew from "@pages/home/images/begambleaware_new.svg";
import gamcare from "@pages/home/images/gamcare.svg";
import adultOnly from "@pages/home/v4/footer/icons/18.svg";
import {
	Address,
	GambleImgWrapper,
	LEGAL_WRAPPER,
	Licence,
	SEALING_WRAPPER,
	TabContentWrapper,
} from "./elements.js";
import useController from "./useController.js";

const isBettoTenant = window.TENANT === "betto";

const TabContent = ({ containers, activeTab, user, history, location }) => {
	const {
		state: { sortedContainer, footerImgWebp, footerImgSvg, footerLogoImgSvg },
	} = useController({ containers, user });
	const isFavoritesBrowse = isBettoTenant && isBettoFavoritesActive(location);
	const getSectionCount = (container) => {
		if (!container?.isActive || !container?.gameList?.length) return 0;
		const topics = container?.topic ? Object.values(container.topic) : [];
		if (topics.length === 0) return 0;
		const isSwiper =
			container?.configs?.gameGrids?.length > 0 ||
			topics.some((t) => t.includes("{user}")) ||
			["aiNewGamesForYou", "userLastPlayed", "aiBecauseYouLiked"].includes(container?.type);
		if (isSwiper) return 1;
		return container?.configs?.gridOptions?.length || 0;
	};

	const sectionStartIndices = [];
	let sectionIdx = 0;
	sortedContainer.forEach((container) => {
		sectionStartIndices.push(sectionIdx);
		sectionIdx += getSectionCount(container);
	});

	const renderSlider = (container, index, globalIndex) => {
		const startIdx = sectionStartIndices[globalIndex];
		return container?.type === "mostPlayed" ? (
			<MostPlayedSlider
				key={container.id}
				data={container}
				activeTab={activeTab}
				size={index == 2 ? "medium" : "small"}
				sectionStartIndex={startIdx}
			/>
		) : (
			<CasinoSlider
				key={container.id}
				data={container}
				activeTab={activeTab}
				size={index == 2 ? "medium" : "small"}
				sectionStartIndex={startIdx}
			/>
		);
	};

	return (
		<TabContentWrapper
			hasCasinoPromotionBanner={window.HAS_CASINO_PROMOTION_BANNER}
			isBetto={isBettoTenant}>
			{isBettoTenant && !isFavoritesBrowse && <BettoLobbyTopBanner activeTab={activeTab} />}
			{isBettoTenant && !isFavoritesBrowse && <BettoWonSlider hideHeader />}
			{window.HAS_CASINO_PROMOTION_BANNER && <PromotionBanner />}
			{window.TENANT === "rollblock" && <RollblockSearchBox />}
			{!isBettoTenant && window.IS_WON_SLIDER_IN_FIRST_PLACE_AND_IN_HOME_PAGE && (
				<WinnersSlider />
			)}

			<GameFilters
				showProvidersFilter
				showCategoriesFilter
				showContainerCategories={isBettoTenant}
				showLobbyFilter={isBettoTenant}
				showIFeelLucky
				showFavorites
				showTournaments
				showSearch
				showTvBet={window.TV_BET_VISIBLE}
				showAllGames
				activeTab={activeTab}
				tournamentOptions={getTournamentOptions()}
				history={history}
				location={location}
			/>

			{isFavoritesBrowse && (
				<Translate>
					{({ translate }) => (
						<BettoFavoritesBrowse
							translate={translate}
							history={history}
							location={location}
						/>
					)}
				</Translate>
			)}

			{!isFavoritesBrowse && (
				<>
					{!isBettoTenant &&
						!window.IS_WON_SLIDER_IN_THIRD_PLACE &&
						!window.IS_WON_SLIDER_IN_FIRST_PLACE_AND_IN_HOME_PAGE && <WinnersSlider />}

					{sortedContainer
						.slice(0, 2)
						.map((container, index) =>
							renderSlider(container, index, sortedContainer.indexOf(container))
						)}

					{!isBettoTenant &&
						window.IS_WON_SLIDER_IN_THIRD_PLACE &&
						!window.IS_WON_SLIDER_IN_FIRST_PLACE_AND_IN_HOME_PAGE && (
							<WinnersSlider colorful={window.IS_HOME_WON_SLIDER_IN_FIRST_PLACE} />
						)}

					{sortedContainer
						.slice(2, 3)
						.map((container, index) =>
							renderSlider(container, index, sortedContainer.indexOf(container))
						)}

					{isBettoTenant ? (
						<BettoProviders activeTab={activeTab} />
					) : (
						<ProvidersSlider activeTab={activeTab} />
					)}

					{sortedContainer
						.slice(3, 5)
						.map((container, index) =>
							renderSlider(container, index, sortedContainer.indexOf(container))
						)}

					{sortedContainer
						.slice(5, containers.length)
						.map((container, index) =>
							renderSlider(container, index, sortedContainer.indexOf(container))
						)}
				</>
			)}

			{!isFavoritesBrowse && !isBettoTenant && window.HAS_FOOTER_BACKGROUND_CARD && (
				<BackgroundCard
					isTransparent={window.FOOTER_BG_TRANSPARENT}
					image={
						window.FOOTER_HAS_INLINE_IMAGE &&
						(footerImgWebp ? footerImgWebp : footerImgSvg)
					}>
					{window.FOOTER_HAS_IMAGE && (
						<img
							src={window.TENANT === "zigybet" ? ZigybetImage : "/logo_white.webp"}
							height={60}
						/>
					)}

					{window.FOOTER_HAS_INLINE_IMAGE && <img src={footerLogoImgSvg} />}
				</BackgroundCard>
			)}
			{!isFavoritesBrowse && !isBettoTenant && <ScrollToTop />}
			{!isFavoritesBrowse && !isBettoTenant && window.CASINO_PAGES_HAS_SEALING && (
				<SEALING_WRAPPER>
					<LEGAL_WRAPPER>
						<Address
							isReversed
							className="address">
							{window.HOME_PAGE_CURACAO_TEXT}
						</Address>
						<Licence
							className="license"
							isReversed>
							{window.HOME_PAGE_LICENCE_TEXT}
						</Licence>
					</LEGAL_WRAPPER>
					<LEGAL_WRAPPER>
						<GambleImgWrapper isReversed>
							<img
								className="lazyload adultOnly"
								data-src={adultOnly}
								width={40}
							/>
							<img
								className="lazyload begambleAware"
								data-src={gamcare}></img>
							<img
								className="lazyload begambleAware"
								data-src={begambleawarenew}></img>
							<a
								target="_blank"
								href={`${window.CURACAO_LINK}${window.CURACAO_TOKEN}`}
								rel="noreferrer">
								<img
									src={
										"https://seal.cgcb.info/1c0246df-1aa7-485a-a24c-21ae5e730000"
									}
									width={100}
									alt="GCB License Seal"
								/>
							</a>
						</GambleImgWrapper>
					</LEGAL_WRAPPER>
				</SEALING_WRAPPER>
			)}
		</TabContentWrapper>
	);
};

export default TabContent;
